module.exports = __webpack_public_path__ + "static/responsive-ac2ffbca38f22f670d7d1c2051defbe8.png";